import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import api from "../../utils/Api";
import { MapPin, Search } from "lucide-react";

const fmtHora = (ts) => {
  if (!ts) return "—";
  const d = new Date(ts);
  return isNaN(d) ? ts : d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
};

export default function Ubicaciones() {
  const { token } = useContext(AuthContext);

  const [empleados, setEmpleados]   = useState([]);
  const [userId, setUserId]         = useState("");
  const [fecha, setFecha]           = useState(new Date().toISOString().slice(0, 10));
  const [registros, setRegistros]   = useState([]);
  const [loading, setLoading]       = useState(false);
  const [buscado, setBuscado]       = useState(false);

  useEffect(() => {
    api.get("/usuarios", { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setEmpleados(Array.isArray(res.data) ? res.data : []))
      .catch(() => {});
  }, [token]);

  const handleBuscar = async () => {
    if (!userId || !fecha) return;
    setLoading(true);
    setBuscado(true);
    try {
      const res = await api.get("/ubicaciones", {
        params: { user_id: userId, fecha },
        headers: { Authorization: `Bearer ${token}` },
      });
      setRegistros(Array.isArray(res.data) ? res.data : []);
    } catch {
      setRegistros([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 className="tn-page-title">Ubicaciones</h1>
        <p className="tn-page-sub">Consulta los registros de posición de tus empleados</p>
      </div>

      {/* Filtros */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginBottom: 24, alignItems: "flex-end" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <label className="tn-label">Empleado</label>
          <select
            className="tn-input tn-select"
            value={userId}
            onChange={e => setUserId(e.target.value)}
            style={{ minWidth: 200, height: 40 }}
          >
            <option value="">Selecciona un empleado</option>
            {empleados.map(e => (
              <option key={e.id} value={e.id}>{e.nombre} {e.apellidos}</option>
            ))}
          </select>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <label className="tn-label">Fecha</label>
          <input
            type="date"
            className="tn-input"
            value={fecha}
            onChange={e => setFecha(e.target.value)}
            style={{ height: 40 }}
          />
        </div>

        <button
          className="tn-btn tn-btn--primary"
          onClick={handleBuscar}
          disabled={!userId || !fecha || loading}
          style={{ height: 40, alignSelf: "flex-end" }}
        >
          <Search size={15} />
          {loading ? "Buscando…" : "Buscar"}
        </button>
      </div>

      {/* Resultados */}
      {buscado && !loading && (
        registros.length === 0 ? (
          <div style={{
            padding: "40px 24px", textAlign: "center",
            color: "var(--clr-muted)", fontSize: 14,
            background: "var(--clr-surface)", borderRadius: 12,
            border: "1px solid var(--clr-border)",
          }}>
            No hay registros de ubicación para ese empleado y fecha.
          </div>
        ) : (
          <div style={{ background: "var(--clr-surface)", borderRadius: 12, border: "1px solid var(--clr-border)", overflow: "hidden" }}>
            <div style={{ padding: "14px 20px", borderBottom: "1px solid var(--clr-border)", display: "flex", alignItems: "center", gap: 8 }}>
              <MapPin size={15} style={{ color: "#FF7A00" }} />
              <span style={{ fontSize: 13, fontWeight: 700, color: "var(--clr-text)" }}>
                {registros.length} registro{registros.length !== 1 ? "s" : ""}
              </span>
            </div>
            <table className="tn-table" style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th className="tn-th">Hora</th>
                  <th className="tn-th">Nota / Cliente</th>
                  <th className="tn-th">Latitud</th>
                  <th className="tn-th">Longitud</th>
                  <th className="tn-th">Ver en mapa</th>
                </tr>
              </thead>
              <tbody>
                {registros.map(r => (
                  <tr key={r.id} className="tn-tr">
                    <td className="tn-td">{fmtHora(r.created_at)}</td>
                    <td className="tn-td">{r.nota || <span style={{ color: "var(--clr-muted)" }}>—</span>}</td>
                    <td className="tn-td" style={{ fontVariantNumeric: "tabular-nums", fontSize: 13 }}>{r.latitud}</td>
                    <td className="tn-td" style={{ fontVariantNumeric: "tabular-nums", fontSize: 13 }}>{r.longitud}</td>
                    <td className="tn-td">
                      <a
                        href={`https://www.google.com/maps?q=${r.latitud},${r.longitud}`}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: "#FF7A00", fontSize: 13, fontWeight: 600, textDecoration: "none" }}
                      >
                        Abrir
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
}
